import { useState } from 'react';

import './App.css';

// Pages
import Home from './Pages/Home/Home';
import ToDoApp from './Pages/ToDoList/TodoApp';

function App() {
  const [activeApp, setActiveApp] = useState("home");


  return (
    <div className="App">
      
      {activeApp == "home" && (
        <Home setActiveApp={setActiveApp}/>
      )}

     

      {activeApp === "todo" && (
        <>
          <button onClick={() => setActiveApp("home")}>Back</button>
          <ToDoApp/>
        </>
      )}
      

      
    </div>
  );
}

export default App;
